import {
  takeLatest, put, call, cancel, SagaReturnType,
} from 'redux-saga/effects';
import { select } from 'app/store/utils/saga/effects';

import * as request from 'app/lib/provider/request';
import Analytics from 'app/lib/Analytics/Analytics';

import * as lastPageActions from '../actions';

export const config = {
  action: lastPageActions.remindHoliday.type,
  method: takeLatest,
};

export function* func(action: lastPageActions.IEmptyPayload) {
  const uuid = yield* select((state) => state.card?.common?.uuid);
  const identity = yield* select((state) => state.card?.common?.identity);
  const { type, param, code } = identity;

  if (!type || !param || !code || !uuid) {
    yield cancel(); return;
  }

  let response: SagaReturnType<typeof request.event> | undefined;
  try {
    response = yield call(() => request.event(uuid, 'holidayRemind'));
  } catch (error) {
    console.error(error);
    yield cancel(); return;
  }

  if (response?.error) {
    console.error(response.error);
    yield cancel(); return;
  }
  Analytics.track().tappedAcceptHolidayReminder();
  yield put(lastPageActions.shiftStep());
}
